import { ComponentProps } from 'react';

import { Button, ButtonProps, Flex, Tooltip } from 'antd';

export interface IToolbarProps extends ComponentProps<'div'> {}

export function Toolbar({ className, ...props }: IToolbarProps) {
	return <Flex {...props} className={className} gap={2} />;
}

interface IToolbarButtonProps extends ButtonProps {
	tooltip?: string;
	pressed?: boolean;
}

export const ToolbarButton = ({ children, className, pressed, tooltip, ...props }: IToolbarButtonProps) => {
	return (
		<Tooltip title={tooltip} styles={{ body: { lineHeight: '24px', fontSize: 12 } }}>
			<Button
				className={className}
				disabled={props.disabled}
				color="default"
				variant={pressed ? 'filled' : 'text'}
				size="small"
				style={{ width: 28, height: 28 }}
				{...props}>
				{children}
			</Button>
		</Tooltip>
	);
};
